import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { SmallLoading } from '../../../../Component/Common/Components/Loading/IntermediateLoading';
import { MDButton } from '../../../../Component/Common/Components/MDButton';
import { LoadingButton } from '@mui/lab';
import { AdvisoryService } from '../../../../Component/Api/Advisory/AdvisoryService';
import { ScorecardReportRequest } from '../../../../Component/Model/Dto/Advisory/Employee';
import { HttpStatusCode } from '../../../../Component/Model/Enum/HttpStatusCode';
import { toast } from 'react-toastify';
import { useRecoilCallback, useResetRecoilState } from 'recoil';
import { AdvisoryReportAtom } from '../../../../State/Advisory/AdvisoryReport.Atom';
import { useHistory } from 'react-router-dom';
import { MDTypography } from '../../../../Component/Common/Components/MDTypography';


interface IProps {
    scorecardId: string;
    scorecardName: string;
    registrationId: string;
    open: boolean;
    closeModal: () => void;
}
export const ScorecardReportModal = ({ scorecardId, scorecardName, registrationId, open, closeModal }: IProps) => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const resetReportAtom = useResetRecoilState(AdvisoryReportAtom);
    const setSelectedReport = useRecoilCallback(({ set }) => (id: number) => {
        set(AdvisoryReportAtom, { id });
    });

    useEffect(() => {
        resetReportAtom();
    }, [])

    const createReport = async () => {
        setIsLoading(true)
        try {
            let scorecardReport: ScorecardReportRequest = {
                registrationId,
                scorecardId
            }
            const result = await AdvisoryService.createScorecardReport(scorecardReport);
            if (result.status === HttpStatusCode.OK) {
                toast.success("Advisory Report Successfully Created");
                closeModal();
                setSelectedReport(result.data);
                history.push(`/advisory/report/:registrationId/:registrationName`);
            }
        } catch (error: any) {
            toast.error(error);
            console.error(error);
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <>
            <Dialog open={open} onClose={() => closeModal()} maxWidth={false}>
                <DialogTitle>
                    <Typography variant="h4">
                        Create Advisory Report
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={closeModal}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ paddingTop: "5px !important", width: "700px" }}>
                    {isLoading ? <SmallLoading /> :
                        <MDTypography variant="span">
                            Are you sure you would like to create an advisory report for scorecard {scorecardName}?
                        </MDTypography>
                    }
                </DialogContent>
                <DialogActions>
                    <MDButton variant='outlined' onClick={() => { closeModal() }} color='primary'>
                        Cancel
                    </MDButton>
                    <LoadingButton variant='contained' loading={isLoading} onClick={() => { createReport() }}>
                        Save
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

